import axios from 'axios'
import Vue from 'vue'
import {ENV_APP} from '../../env'

axios.defaults.baseURL = ENV_APP.apiUri

Vue.prototype.api = axios
